/**
 * Тексты продления подписки (Flow Point, этап 2 часть 3).
 *
 * §10.4 плана: шаблон один, числа подставляются из данных:
 *   - N ≥ 2: «Продлите сейчас{скидка}, и серия {N} дн. не прервётся»;
 *   - N < 2: «Продлите сейчас{скидка} — и продолжайте» (про серию не говорим);
 *   - `{скидка}` = « со скидкой 50% от ваших FP», если FP-скидка > 0,
 *     иначе — пусто (про скидку не упоминаем вовсе).
 *
 * Число N — это `checkin.streak_days` из `GET /habits/{id}/today`
 * (серия считается на сервере). До этапа 5 (материализованная серия) это
 * производная величина по чек-инам; после этапа 5 то же поле будет
 * читаться из `memberships.current_streak` — текст и API не меняются.
 */
export function renewMotivation(streakDays: number, hasDiscount: boolean): string {
  const discount = hasDiscount ? " со скидкой 50% от ваших FP" : "";
  if (streakDays >= 2) {
    return hasDiscount
      ? `Продлите сейчас${discount}, и серия ${streakDays} дн. не прервётся`
      : `Продлите сейчас — и серия ${streakDays} дн. не прервётся`;
  }
  return `Продлите сейчас${discount} — и продолжайте`;
}
